export default "__VITE_ASSET__DlJ5YCgy__"